var map = {
	"./Charlottenburg-Wilmersdorf.svg": 1085,
	"./Friedrichshain-Kreuzberg.svg": 1086,
	"./Lichtenberg.svg": 1087,
	"./Marzahn-Hellersdorf.svg": 1088,
	"./Mitte.svg": 1089,
	"./Neukoelln.svg": 1090,
	"./Pankow.svg": 1091,
	"./Reinickendorf.svg": 1092,
	"./Spandau.svg": 1093,
	"./Steglitz-Zehlendorf.svg": 1094,
	"./Tempelhof-Schoeneberg.svg": 1095,
	"./Treptow-Koepenick.svg": 1096,
	"./berlin_logo.png": 1097
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1084;